import { createFileRoute } from '@tanstack/react-router'

import { CustomerPageWrapper } from '@/components/molecules/customer-page-wrapper'
import PageHeader from '@/components/molecules/shared/page-header'
import { StripeCallback } from '@/features/accounting/pages/stripe-callback'
import Head from '@/lib/navigation/head'

function StripeCallbackRoute() {
  return (
    <>
      <Head>
        <title>Connecting Stripe | Nonresident Tax</title>
      </Head>
      <CustomerPageWrapper stickyHeader={<PageHeader title="Connect Stripe" sticky />}>
        <StripeCallback />
      </CustomerPageWrapper>
    </>
  )
}

// `connections_` opts out of nesting under the `connections` route, which has no <Outlet />.
export const Route = createFileRoute('/_shell/accounting/connections_/stripe/callback')({
  component: StripeCallbackRoute,
})
